export default __webpack_public_path__ + "static/media/404.3aaffda7.png";